import { type ReactElement } from 'react'

function StandardPayBackgroundGraphic (): ReactElement {
  return (
    <svg id="Standard-Pay-Background-Graphic" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1700 2146.59">
      <path
        id="Standard-Pay-Background-Graphic-Path-1"
        fill="none"
        d="M0.55 2141.99L0.55 2146.59 944.71 2146.59 939.33 2141.99 0.55 2141.99z"
      />
      <path
        id="Standard-Pay-Background-Graphic-Path-2"
        fill="#F6A48F"
        d="M175.08 702.88a371.63 371.63 0 010-529.61L350.25 0H0v1169.92l303.87-339.64z"
      />
      <path
        id="Standard-Pay-Background-Graphic-Path-3"
        d="M175.54 702.88L304 830.28l179.59-201.2-95.41-85.52A168.64 168.64 0 01376 303.94L653.2 0H350.3L175.54 173.27a372.21 372.21 0 000 529.61z"
        style={{ isolation: 'isolate' }}
        fill="#F49178"
        fillRule="evenodd"
      />
      <path
        id="Standard-Pay-Background-Graphic-Path-4"
        d="M386.51 543.56l95.67 85.52L1045.21 0h-393l-277.9 303.94a168.32 168.32 0 0012.2 239.62z"
        style={{ isolation: 'isolate' }}
        fill="#F37E60"
        fillRule="evenodd"
      />
      <path
        id="Standard-Pay-Background-Graphic-Path-5"
        fill="#373740"
        d="M1037.73 0L479.73 629.08 301.27 830.28 0 1169.92 0 1206.89 0 1338.66 0 2141.99 942.97 2141.99 1700 2141.99 1700 1206.89 1700 802.67 1700 492.65 1700 0 1037.73 0z"
      />
    </svg>
  )
}

export default StandardPayBackgroundGraphic
